import LeaseViewBar from "../components/bars/leaseViewBar";
import ChargesCard from "../components/cards/chargesCard";
import LeaseInfoCard from "../components/cards/leaseInformationCard";
import NoteLogsCard from "../components/cards/noteLogsCard";
import TransactionHistory from "../components/transactionHistory";
import { DocumentStore } from "../components/documentStore";
import { ResponsiveRow } from "../constants/layout.constants";
import Permit from "../util/permit";
import {useSelector} from "react-redux";
import {useEffect, useState, useMemo} from "react";
import {formatDate, isEmptyString, isNullUndefined} from "../util/util";
import MuiDataGrid from "../components/modules/MuiDataGrid";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { Delete, Edit, Visibility } from "@mui/icons-material";
import ViewRsrModal from "../components/modals/viewRsrModal";
import { Button, Typography } from "@mui/material";
import { getRsrForApproval } from "../services/shared.service";
import CreateRSRInvoiceModal from "../components/modals/accounting/invoice/createRSRInvoiceModal";
import { issueResponseMessage, issueWarnMessage } from "../actions/message";
import { deleteRSR, updateRSR, viewRSR } from "../services/lease.service";
import { printInvoice } from "../services/print.service";
import ConfirmationModal from "../components/modals/confirmation";

export default function LeaseView(props) {
    const user = useSelector((state) => state.auth.user);
    const [proxySubscription, setProxySubscription] = useState("")
    const [proxyFacility, setProxyFacility] = useState("")
    const [viewRsr, setViewRsr] = useState(false);
    const [editRsr, setEditRsr] = useState(false);
    const [bulkFileProgress] = useState(0);
    const [selectedRsr, setSelectedRsr] = useState({});
    const [confirm, setConfirm] = useState(false);

    useEffect(() => {
      if (!isNullUndefined(user) && (user.proxySubscription !== "" || user.proxyFacility !== "")) {
        setProxySubscription(user.proxySubscription)
        setProxyFacility(user.proxyFacility)
      }
    }, []);

    useEffect(() => {
      if (!isEmptyString(proxyFacility) || !isEmptyString(proxySubscription)) {
        if(user.proxySubscription !== proxySubscription || user.proxyFacility !== proxyFacility){
            props.setTask("")
        }
      }
    }, [user.proxyFacility, user.proxySubscription]);

    const handleViewRsrClick = async (row) => {
      const response = await getRsrForApproval(row.id)
      setSelectedRsr(response)
      setViewRsr(true)
    }

    const handleRsrEditClick = async (row) => {
      try {
          const data = await viewRSR(row?.id);
          setSelectedRsr(data);
          setEditRsr(true)
      } catch (error) {
          console.error("Error fetching RSR data", error);
      }
    }

    const handleDeleteClick = (row) => {
      setSelectedRsr(row);
      setConfirm(true);
    }

    const handleConfirmationClose = () => {
      setSelectedRsr(null);
      setConfirm(false);
    }

    const handleRSRDeletion = async (rsrId) => {
      try {
        const data = await deleteRSR(rsrId)
        issueResponseMessage(data)
        setConfirm(false);
        props?.fetchRsrs(props.selectedLease.id)
      } catch (error) {
        console.error("Error when deleting RSR")
      }
    }

    function handleEditSave(chargeItems) {
      if (chargeItems.some((chargeItem) => chargeItem?.chargeCode === "REN" && !chargeItem?.revenueForThePeriod)) {
          issueWarnMessage("A revenue for the period is required for all Rent charge items");
          return;
      }
      setEditRsr(false);
      let data = {
          rsrId: selectedRsr?.id,
          // revenueForThePeriod: revenueForThePeriod,
          rsrChargeItems: chargeItems,
      }

      updateRSR(data, selectedRsr?.id)
          .then((res) => {
              issueResponseMessage(res);
              return props?.fetchRsrs(selectedRsr.leaseId);
          })
          .catch((err) => {
              console.error("Error updating RSR or fetching reminders", err);
          })
    }

    const handleViewRsrClose = () => {
      setViewRsr(false)
      setSelectedRsr({})
    }

    const rsrColumns = useMemo(() => [
      {
        headerName: "Date",
        field: "notificationDate",
        minWidth: 150,
        flex: 1.5,
        valueFormatter: (row) => formatDate(row.value),
      },
      {
        headerName: "Completed On",
        field: "completedOn",
        minWidth: 150,
        flex: 1.5,
        valueFormatter: (row) => (isNullUndefined(row.value) ? "" : formatDate(row.value)),
      },
      {
        headerName: "Completed By",
        field: "completedByName",
        minWidth: 150,
        flex: 1.5,
      },
      {
        headerName: "Invoice",
        field: "invoiceNumber",
        minWidth: 150,
        flex: 1.5,
        valueFormatter: (row) => (isEmptyString(row.value) ? "" : row.value),
        renderCell: (params) => {
          const financial = params.row;
          return (
            <Button
              variant="text"
              onClick={() => printInvoice(financial.invoiceId)}
            >
              {financial.invoiceNumber}
            </Button>
          );
          
        }
      },
      {
        headerName: "Status",
        field: "status",
        minWidth: 150,
        flex: 1.5,
      },
      {
        headerName: "Actions",
        field: "actions",
        minWidth: 100,
        flex: 0.5,
        type: "actions",
        getActions: (params) => {
          let arr = [];
          arr.push(
            <GridActionsCellItem
              icon={<Visibility />}
              label="View"
              onClick={() => handleViewRsrClick(params.row)}
              showInMenu
            />
          );

          if((params.row.invoiceId === null || isEmptyString(params.row.invoiceId))) { 
            arr.push(
              <GridActionsCellItem
                icon={<Edit />}
                label="Edit"
                onClick={() => handleRsrEditClick(params.row)}
                showInMenu
              />
            )
          }

          if((params.row.invoiceId === null || isEmptyString(params.row.invoiceId)) && params.row.status === "Pending" && user.proxyRole === "BLDIR") { 
            arr.push(
              <GridActionsCellItem
                icon={<Delete sx={{color: "red"}} />}
                label="Delete"
                onClick={() => handleDeleteClick(params.row)}
                showInMenu
              />
            )
          }

          return arr;
        },
      },
    ]);

  return (
    <Permit
      roles="BLDIR,BLDMG,REC,OWN,CS"
      services="PREMIUM,CORE,LEAN"
      noPermittedServiceMessage={{
        title: "Access Denied",
        body: (
          <>
            Your current role and/or facility is not permitted to view this
            page. <br /> Please contact your system admin if you feel this is an
            error.
          </>
        ),
      }}
    >
      <ResponsiveRow
        container
        sx={{
          flexDirection: "column",
          flexWrap: "nowrap",
          width: "100%",
          height: "auto",
          justifyContent: { xs: "flex-start", lg: "flex-start" },
          alignItems: "flex-start",
          padding: 0,
        }}
      >
        <LeaseViewBar
          handleStatementYearChange={props.handleStatementYearChange}
          statementYear={props.statementYear}
          handleUnitSwapClick={props.handleUnitSwapClick}
          selectedLease={props.selectedLease}
          setTask={props.setTask}
        />

        <ResponsiveRow
          sx={{
            width: "100%",
            height: "auto",
            flexDirection: { xs: "column", lg: "row" },
            flexWrap: "nowrap",
            justifyContent: { xs: "center", lg: "space-between" },
            alignItems: "center",
            padding: 0,
            margin: "10px auto 5px auto",
          }}
        >
          <LeaseInfoCard selectedLease={props.selectedLease} />
        </ResponsiveRow>
        <ResponsiveRow
          sx={{
            width: "100%",
            height: "auto",
            flexDirection: { xs: "column", lg: "row" },
            flexWrap: "nowrap",
            justifyContent: "space-between",
            alignItems: "center",
            margin: { xs: 0, lg: "10px auto 5px auto" },
            padding: 0,
          }}
        >
          <NoteLogsCard
            width="33.3%"
            notesMode={"Lease"}
            contract={props.selectedLease}
            height="500px"
          />

          <ChargesCard
             width={"33.3%"}
            chargesMode={"Lease"}
            selectedLease={props.selectedLease}
            charges={props.selectedLease.leaseChargeItems}
          />

          <DocumentStore
            height="500px"
            maxWidth="33.3%"
            files={[
              ...props.selectedLease.imageFiles,
              ...props.selectedLease.otherDocuments,
            ]}
            item={props.selectedLease}
            type={"Lease"}
          />
        </ResponsiveRow>

        <TransactionHistory
          transactionMode={"Lease"}
          contract={props.selectedLease}
          handleVoidClick={props.handleVoidClick}
          height="80vh"
        />
        {props.selectedLease?.hasRevenueSharing &&  (
          <ResponsiveRow marginTop={"1rem"} sx={{ width: "100%", padding: 0 }}>
            <Typography
                sx={{
                    width: "100%",
                    padding: "20px 20px 0 20px",
                    textAlign: "start",
                    marginBottom: "1rem",
                }}
                variant="h4"
            >
              Revenue Sharing Requests (RSR)
            </Typography>
            <MuiDataGrid
              dataGridColumns={rsrColumns}
              dataGridRows={props?.rsrs}
              loading={props?.loading}
              height="60vh"
              totalRows={props?.rsrs.length}
              currentSelectionModel={props?.rowSelectionModel}
              handleSelectedRows={props?.setRowSelectionModel}
              handlePageLoad={props?.setPaginationModel}
              serverPagination={true}
              noSelection={true}
              noBoxShadow={true}
            />
          </ResponsiveRow>
        )}

        {viewRsr && (
          <ViewRsrModal
            open={viewRsr}
            handleClose={handleViewRsrClose}
            rsrItem={selectedRsr}
          />
        )}

        {editRsr && (
          <CreateRSRInvoiceModal
            handleCancelClicked={() => setEditRsr(false)}
            task={"Edit"}
            showAddInvoiceForm={editRsr}
            saveInvoiceClicked={handleEditSave}
            rsr={selectedRsr}
            bulkFileProgress={bulkFileProgress}
          />
        )}

        {confirm && (
          <ConfirmationModal
            showConfirmationModal={confirm}
            handleConfirmationClose={handleConfirmationClose}
            title={"Confirm Delete of Revenue Share Request"}
            severity={"warning"}
            body={
              `Are you sure you want to delete this RSR`
            }
            positiveText={"Delete"}
            negativeText={"Cancel"}
            positiveAction={() =>
              handleRSRDeletion(selectedRsr.id)
            }
            negativeAction={handleConfirmationClose}
          />
        )}
      </ResponsiveRow>
    </Permit>
  );
}
